// extracted by mini-css-extract-plugin
export default {"card":"Card_card__JgwSj","interactive":"Card_interactive__RUlT3","done":"Card_done__uj6HZ"};